export const AppMessages: Map<string, string> = new Map([
  ["zaphod", "this is text"],
  ["homer", "8"],
  ["yoda", "6"],
  ["EndDate must greater than StartDate", "End Date must be greater than Start Date"],
]); // using tuples to define values: [string, string][]
